module.exports = __webpack_public_path__ + "img/login-img.74dfb8cd.webp";